<template>
    <div class="banner">
        <div class="swiper-container">
            <div class="swiper-wrapper">
                <template v-for="(item, index) in bannersList">
                    <div :key="'swiper' + index" class="swiper-slide">
                        <!-- <img :src="'http://mengxiangqingdan.com' + item"> -->
                        <img :data-src="item" class="swiper-lazy">
                        <div class="swiper-lazy-preloader"></div>
                    </div>
                </template>
            </div>
            <div class="swiper-pagination swiper-pagination-bullets"></div>
        </div>
    </div>
</template>

<script>
import Swiper from 'swiper';
require('@/assets/styles/swiper3.min.css');
export default {
    name: 'Banners',
    data () {
        return {
            banner: {}
        };
    },
    props: ['bannersList'],
    mounted () {
        this.setBanner();
    },
    methods: {
        setBanner () {
            let banner = new Swiper('.swiper-container', {
                // autoplay: 5000,
                pagination: '.swiper-pagination',
                observer: true,
                lazyLoading : true,
                observeParents: true
            });
            this.banner = banner;
        }
    }
};
</script>

<style lang="scss">
.banner {
    .swiper-container {
        width: 100%;
        max-width: 420px;
        border: 0;
        height: 62.5vw;
        max-height: 262.5px;
        img {
            width: 100%;
            border: 0;
        }
        .swiper-pagination {
            bottom: rem(10px);
            // text-align: left;
            .swiper-pagination-bullet {
                width: rem(8px);
                height: rem(8px);
                margin-left: rem(5px);
                background: #FFFFFF;
                border-radius: rem(4px);
                opacity: .52;
            }
            .swiper-pagination-bullet-active {
                background: #FFFFFF;
                opacity: 1;
            }
        }
        .swiper-lazy-preloader {
            // top: rem(100px)
            border: 0;
        }
    }
}
</style>

